
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/static-shop",
      function () {
        return require("private-next-pages/static-shop.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/static-shop"])
      });
    }
  